@let currentActionType = actionType();
<button [ngClass]="'action-' + currentActionType" [class.loading]="loading()" (click)="performAction(currentActionType)">
    <div class="loading-indicator"></div>

    @if (currentActionType === 'play' || currentActionType === 'resume' || currentActionType === 'pause') {
        <img [src]="currentActionType === 'pause' ? 'assets/images/voice/pause-outline-filled.svg' : 'assets/images/voice/play-circle.svg'"
             alt="play"
             class="action-image" />
    }
</button>
<button (click)="copy()">
    <img src="assets/images/voice/copy.svg"
            alt="play"  class="action-image" />
</button>
